export default "__VITE_PUBLIC_ASSET__780e86ad__"